<template>
  <div class="account-page">
    <!-- Main Wrapper -->
    <div class="main-wrapper">
      <!-- Header -->
      <layout-header-login />
      <!-- /Header -->

      <!-- Page Content -->
      <div class="content">
        <div class="custom-container">
          <div class="row justify-content-center">
            <div class="col-md-9">
              <!-- Login Tab Content -->
              <div class="account-content">
                <div class="row align-items-center justify-content-center">
                  <div class="col-md-7 col-lg-6 login-left">
                    <img
                      src="@/assets/img/login-banner.png"
                      class="img-fluid"
                      alt="Dreams Library Login"
                    />
                  </div>
                  <div class="col-md-12 col-lg-6 login-right">
					<!-- <div class="alert alert-warning alert-dismissible fade show text-center" role="alert">
						<strong>#LearnDoTeach</strong> Ayo Belajar sekarang juga!
					</div> -->
                    <div class="login-header text-center">
                      <h3><strong>#LearnDoTeach</strong> Ayo Belajar sekarang juga!</h3>
					</div>
					<div class="alert alert-danger" v-if="errors">
						{{ errors }}
					</div>
					<div class="alert alert-warning" v-if="msg">
						{{ msg }}
					</div>
                    <form @submit.prevent="userLogin">
                      <div class="form-group form-focus">
                        <input type="email" class="form-control floating" v-model="form.email" />
                        <label class="focus-label">Email</label>
                      </div>
                      <div class="form-group form-focus">
                        <input type="password" class="form-control floating" v-model="form.password" />
                        <label class="focus-label">Kata Sandi</label>
                      </div>
                      <button
                        class="btn btn-primary btn-block btn-lg login-btn"
                        type="submit"
                      >
                        Masuk
                      </button>
                      <div class="text-right">
                        <router-link class="forgot-link" to="/forgot-password"
                          >Lupa	Kata Sandi ?</router-link
                        >
                      </div>
                      <div class="login-or">
                        <span class="or-line"></span>
                        <span class="span-or">or</span>
                      </div>
                      <div class="row form-row social-login">
                        <!-- <div class="col-6">
                          <a href="#" class="btn btn-facebook btn-block"
                            ><i class="fab fa-facebook-f mr-1"></i> Login</a
                          >
                        </div> -->
                        <!-- <div class="col-12">
                          <a href="#" class="btn btn-google btn-block"
                            ><i class="fab fa-google mr-1"></i> Masuk dengan Googlee</a
                          >
                        </div> -->
                      </div>
                      <div class="text-center dont-have">
                        Belum punya akun?
                        <router-link to="/register">Daftar di sini</router-link>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
              <!-- /Login Tab Content -->
            </div>
          </div>
        </div>
      </div>
      <!-- /Page Content -->

      <!-- Footer -->
      <layout-footer />
      <!-- /Footer -->
    </div>
    <!-- /Main Wrapper -->
  </div>
</template>

<script>  

import Util from '../../../assets/utils/utils'
import {mapGetters} from 'vuex'

  export default {  
    data(){
      return {
        form: {
          email: '',
          password: '',
        },
        errors: null,
        msg: null
      }
    },
    computed: {
        ...mapGetters({ 
            isLoggedIn: 'isLoggedIn',
            user: 'user',
        }),
        currentPath() {
            return this.$route.name
        }
    },
    created:function () {
      // console.log("ini user ");
      // console.log(this.user);
      if(this.user){
        if(this.user.hak_akses == '1')
          this.$router.push({name: 'siswa-profile-settings'})
        else if(this.user.hak_akses == '2')
          this.$router.push({name: 'instructor-profile-settings'})
        else if(this.user.hak_akses == '3')
          this.$router.push({name: 'admin-profile-settings'})
      }
        
    },
    methods: {
      userLogin () { 
      this.$store.dispatch('login', this.form)
      .then(response => {
				if(response.data.status == "error"){
					this.errors = response.data.message;          
				} else {
          // var resp = JSON.parse(response);
          // console.log(response.data.data.ha);
          if(response.data.data.ha == '1')
            this.$router.push({name: 'home'}) //siswa-paket-belajar //siswa-paket-saya
          else if(response.data.data.ha == '2')
            this.$router.push({name: 'instructor-profile-settings'})
          else if(response.data.data.ha == '3')
            this.$router.push({name: 'admin-profile-settings'})
          else if(response.data.data.ha == '4')
            this.$router.push({name: 'home'}) 
        }
        
      }).catch(error => {
        this.errors = error;// error.response.data.errors
      })
    } 
    }
  }
</script>


// WEBPACK FOOTER //
// src/components/Pages/Login/index.vue